/* FLGNTLT Startseite — Kampagnen-Info im Video (snippets/flgntlt-video-info.liquid, CEO 19.10.2026).
 * Fortschrittsbalken je Video und „Ton an" (nur wo das Snippet einen Knopf ausgibt). Nur am Handy sichtbar.
 *   - Ton an schaltet alle anderen Videos stumm und spielt das eigene weiter (Tipp = Nutzergeste, iOS erlaubt das).
 *   - Verlässt das Video zu drei Vierteln das Bild, wird es wieder stumm — niemand soll Ton aus einem Video
 *     hören, das er nicht mehr sieht.
 *   - Das Snippet bindet dieses Skript je Slide ein ⇒ Schutz gegen doppelte Ausführung.
 */
(function () {
  'use strict';
  if (window.__flgntltVideoInfo) return;
  window.__flgntltVideoInfo = true;

  function videoVon(info) {
    var slide = info.closest('.slideshow__slide');
    return slide ? slide.querySelector('video.mobile-video') : null;
  }

  function setzen(knopf, an) {
    knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    knopf.textContent = an ? knopf.getAttribute('data-aus') : knopf.getAttribute('data-an');
  }

  function alleStumm(ausser) {
    document.querySelectorAll('[data-fvi]').forEach(function (info) {
      var v = videoVon(info);
      var k = info.querySelector('[data-fvi-ton]');
      if (v && v !== ausser) v.muted = true;
      if (k && v !== ausser) setzen(k, false);
    });
  }

  function einrichten(info) {
    if (info.__fvi) return;
    var v = videoVon(info);
    if (!v) {
      console.error('[flgntlt-video-info] kein Handy-Video im Slide', info.getAttribute('data-fvi'));
      return;
    }
    info.__fvi = true;

    var balken = info.querySelector('[data-fvi-balken]');
    if (balken) {
      v.addEventListener('timeupdate', function () {
        if (v.duration > 0) balken.style.width = Math.min(100, (v.currentTime / v.duration) * 100).toFixed(2) + '%';
      });
    }

    var knopf = info.querySelector('[data-fvi-ton]');
    if (!knopf) return;
    knopf.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var einschalten = v.muted;
      if (einschalten) {
        alleStumm(v);
        v.muted = false;
        v.volume = 1;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function (err) { console.error('[flgntlt-video-info] Abspielen mit Ton abgelehnt:', err); });
      } else {
        v.muted = true;
      }
      setzen(knopf, einschalten);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.intersectionRatio < 0.25 && !v.muted) { v.muted = true; setzen(knopf, false); }
        });
      }, { threshold: [0, 0.25] }).observe(info);
    }
  }

  // Nur das ERSTE Video, wenn es oben auf der Seite steht: auf den sichtbaren Platz kürzen (CSS .fvi-passt), damit der
  // Text unten schon beim ersten Aufruf im Bild steht. Gemessen wird der Abstand zum Seitenanfang (Kopf +
  // Ankündigungsleiste); neu nur bei geänderter Breite (Drehen), nicht bei jedem Scroll-Resize der Browserleisten.
  var breite = 0;
  function erstesEinpassen() {
    if (window.innerWidth === breite) return;
    breite = window.innerWidth;
    var info = document.querySelector('[data-fvi]');
    var slide = info && info.closest('.slideshow__slide');
    if (!slide) return;
    var oben = slide.getBoundingClientRect().top + window.scrollY;
    if (window.innerWidth >= 750 || oben > window.innerHeight * 0.4) { slide.classList.remove('fvi-passt'); return; }
    slide.style.setProperty('--fvi-oben', Math.round(oben) + 'px');
    slide.classList.add('fvi-passt');
  }

  function alle() {
    document.querySelectorAll('[data-fvi]').forEach(einrichten);
    erstesEinpassen();
  }
  window.addEventListener('resize', erstesEinpassen);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
